import { classpartConstants } from '../constant/classpart'


export default function classpart(state = {}, action) {
  switch (action.type) {

    case classpartConstants.READ_CLASSPARTS_SUCCESS:
      return { ...state, totalCount: action.resp.totalCount }

    // case classpartConstants.READ_CLASSPARTS_SUCCESS:
    //   return { ...state, readAll: action.resp, isReady: true }

    // case classpartConstants.READ_CLASSPARTS_FAILURE:
    //   return { ...state, isReady: true }

    default:
      return state
  }
}